import React from 'react';

function Footer() {
  return (
    <footer className="text-center py-4 mt-10 font-mono text-base">
      <p className="text-black-600 text-lg">
      <a
          href="https://github.com/Ash1799Maurya/Portfolio"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sky-400 hover:underline"
        >
           Coded {' '}
        </a>
           by Ashwini Maurya
      </p>
    </footer>
  );
}

export default Footer;
